import { render, staticRenderFns } from "./MainStore.vue?vue&type=template&id=424efc46&scoped=true"
import script from "./MainStore.vue?vue&type=script&lang=js"
export * from "./MainStore.vue?vue&type=script&lang=js"
import style0 from "./MainStore.vue?vue&type=style&index=0&id=424efc46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424efc46",
  null
  
)

export default component.exports